import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import { App } from './App';
import { useAuthStore } from './lib/auth';

// Persistierten Token lesen, BEVOR React rendert.
useAuthStore.getState().hydrate();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root-Element #root fehlt in index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
